import { Link } from "react-router-dom";

export function Imprint() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-5 pt-8 pb-12">
      <article className="w-full max-w-[680px] bg-white px-8 pt-9 pb-10 relative animate-ink-in">
        <Link
          viewTransition
          to="/"
          className="text-[0.95rem] text-[rgba(31,29,25,0.72)] hover:text-[rgba(31,29,25,1)] underline underline-offset-4 decoration-1 mb-6 inline-block"
        >
          ← Back
        </Link>

        <h1 className="text-[1.4rem] font-normal mb-6">Impressum</h1>

        <section className="text-[0.95rem] space-y-6">
          <div>
            <h2 className="text-[1.02rem] mb-2">Angaben gemäß § 5 TMG</h2>
            <p className="text-[rgba(31,29,25,0.72)]">
              Karim Siala
              <br />
              Jülicher Str. 209q-s
              <br />
              52070 Aachen
              <br />
              Germany
            </p>
          </div>

          <div>
            <h2 className="text-[1.02rem] mb-2">Kontakt</h2>
            <p className="text-[rgba(31,29,25,0.72)]">
              E-Mail: karim@roboticscollective.org
            </p>
          </div>

          <div>
            <h2 className="text-[1.02rem] mb-2">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p className="text-[rgba(31,29,25,0.72)]">
              Karim Siala
              <br />
              Jülicher Str. 209q-s
              <br />
              52070 Aachen
            </p>
          </div>

          <div>
            <h2 className="text-[1.02rem] mb-2">Haftungsausschluss</h2>

            <h3 className="text-[0.95rem] font-normal mt-3 mb-1">
              Haftung für Inhalte
            </h3>
            <p className="text-[rgba(31,29,25,0.72)]">
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
              Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
              können wir jedoch keine Gewähr übernehmen.
            </p>

            <h3 className="text-[0.95rem] font-normal mt-3 mb-1">
              Haftung für Links
            </h3>
            <p className="text-[rgba(31,29,25,0.72)]">
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Für die Inhalte der
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
              der Seiten verantwortlich.
            </p>
          </div>
        </section>
      </article>

      <footer className="mt-7 text-[0.70rem] tracking-[0.1em] text-[rgba(31,29,25,0.62)]">
        © {new Date().getFullYear()}
      </footer>
    </main>
  );
}
